import React from 'react';
import { useMemo } from 'react';
import { memo, useRef } from 'react';
import { useDrag, useDrop } from 'react-dnd';
import { useSelector } from 'react-redux';
import { __ } from '../../lib/i18n.js';
import { ItemTypes } from './ItemTypes.js';

const style = {
  cursor: 'move',
};

export const Card = memo(function Card({ p, moveCardHover, moveCardDrop, e }) {
  const {
    merchantCategories: { category },
  } = useSelector((state) => state);
  const { id } = p;
  const ref = useRef(null);
  const [{ isDragging, handlerId }, connectDrag] = useDrag({
    type: ItemTypes.CARD,
    item: { id },
    collect: (monitor) => {
      const result = {
        handlerId: monitor.getHandlerId(),
        isDragging: monitor.isDragging(),
      };
      return result;
    },
  });
  const [, connectDrop] = useDrop({
    accept: ItemTypes.CARD,
    hover({ id: draggedId }) {
      if (draggedId !== id) {
        moveCardHover(draggedId, id);
      }
    },
    drop() {
      moveCardDrop();
    },
  });
  connectDrag(ref);
  connectDrop(ref);

  const opacity = isDragging ? 0.5 : 1;
  const containerStyle = useMemo(() => ({ ...style, opacity }), [opacity]);

  return (
    <div
      data-handler-id={category !== 'ALL' ? handlerId : null}
      ref={category !== 'ALL' ? ref : null}
      style={category !== 'ALL' ? containerStyle : {}}>
      {e}
    </div>
  );
});
